
// --- Section expand ---

$('.expand-hidden').addClass('hidden')
$('.expand-hidden').slideUp(
  function(){
    $('.expand-hidden').removeClass('hidden')
  }
)
$('.expand-bottom .more2').click(function(){
  $('.expand-hidden').slideToggle()
  var t = $('.expand-bottom .more2').text() == 'Collapse' ? 'Expand to learn more' : 'Collapse'
  $('.expand-bottom .more2').text(t)
})



// --- Load more boxes (for sites with no filters) ---

$('.loadmore-list.collapsed').addClass('hidden')
$('.loadmore-list.collapsed').slideUp(
  function(){
    $('.loadmore-list.collapsed').removeClass('hidden')
  }
)

$('.loadmore-bottom .more2').click(function (){

  // Multiple loader using Masonry
  if ($(this).parents('.loadmore-multiple').length > 0) {
    $(this).parent().parent().find('.loadmore-list.collapsed').each(function(i){
      if (i > 5) {
        return false
      }
      $(this).removeClass('collapsed').show()
    })
    $('.grid').masonry()

  // Regular loader
  } else {
    $(this).parent().parent().find('.loadmore-list.collapsed').each(function(i){
      if (i > 0) {
        return false
      }
      $(this).removeClass('collapsed').slideDown()
    })
  }

  if ($(this).parent().parent().find('.loadmore-list.collapsed').length <= 0) {
    $(this).parent().parent().find('.loadmore-bottom').slideUp()
  } else {
    $(this).parent().parent().find('.loadmore-bottom').slideDown()
  }
})


// // --- Expanders ---

// $(document).ready(function(){

//   //Open all expanders which has the opened class
//   $(".expanders .expander-box.opened .expander-content").slideDown();

//   const toggleExpand = (e) => {
//     const parentEle = $(e.currentTarget).parent();
//     const expanderContentEle = parentEle.find('.expander-content');
//     if(parentEle.hasClass('opened')) {
//       parentEle.removeClass('opened');
//       $(e.currentTarget).attr('aria-expanded', 'false');
//       $(e.currentTarget).attr('aria-pressed', 'false');
//       expanderContentEle.slideUp();
//     } else {
//       parentEle.addClass('opened');
//       expanderContentEle.slideDown();
//       $(e.currentTarget).attr('aria-expanded', 'true');
//       $(e.currentTarget).attr('aria-pressed', 'true');
//     }
//   }

//   const expanderTitle = $('.expander-title');

//   expanderTitle.click(function(e){
//     toggleExpand(e)
//   });

//   expanderTitle.keydown(function(e){
//     let key = e.which;
//     if(key === 13 || key === 32){
//       toggleExpand(e)
//     }
//   });
// });